import React, {useEffect, useState, useContext} from "react";
import Bpmn from "../../Componnets/Bpmn/Bpmn";
import http from "../../../services/api/utilities/http";
import appContext from "../../../context/appContext";

const AutomaticBpmnGenerate = () => {

  const [status, setStatus] = useState(null);
  const [xml, setXml] = useState(null);
  const context = useContext(appContext);

  const getData = () => {
    http({
      method: 'post',
      url: `process_mining/bpmn/${context.handleUid().uid}`,
      headers: {Authorization: 'Bearer ' + localStorage.getItem('token')},
    })
      .then(res => {
        setXml(res.data);
        setStatus('success');
      })
      .catch(err => {
        console.log(err)
      })
  }

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      {status === 'success' && <Bpmn diagramXML={xml} />}
    </>
  )
};

export default AutomaticBpmnGenerate;
